export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "controller.worker.35d6bb478b77024669d3.worker.js");
}
